export default "__VITE_ASSET__B0t6nPOb__"